<template>
  <b-modal
    size="xl"
    ref="my-hr-modal-setting"
    scrollable
    title="Permissions details"
  >
    <div class="container-fluid">
      <div class="row">
        <div class="col-xs-3 col-sm-3 col-lg-3 col-md-3 small">
          <b>Role</b><br />
          <p>{{ getClientDetailsForSettingsModalObj.name }}</p>
          <hr />
          <b>Description</b>
          <p>
            {{ getClientDetailsForSettingsModalObj.description }}
          </p>
          <hr />
          <b>Custom</b>
          <p>
            {{ getClientDetailsForSettingsModalObj.isCustom ? "Yes" : "No" }}
          </p>
          <hr />
          <b>Admin Access</b>
          <p>
            {{
              getClientDetailsForSettingsModalObj.allowAdminAccess
                ? "Yes"
                : "No"
            }}
          </p>
          <hr />
          <b>Overwrite Unit Roles</b>
          <p>
            {{
              getClientDetailsForSettingsModalObj.overwriteUnitRoles
                ? "Yes"
                : "No"
            }}
          </p>
        </div>
        <div class="col-xs-9 col-sm-9 col-lg-9 col-md-9 small">
          <b>Permissions</b>
          <b-table-simple class="my-2" responsive small bordered>
            <b-thead>
              <b-tr>
                <b-th v-for="column in permissionsFields" :key="column.key">{{
                  column.key
                }}</b-th>
              </b-tr>
            </b-thead>
            <b-tbody
              v-for="modules in getClientRolesModulesArr"
              :key="modules.module_id"
            >
              <b-tr>
                <b-td>
                  <p>{{ modules.module_name }}</p>
                </b-td>
                <b-td class="text-center">
                  <i
                    v-if="modules.allow_view"
                    class="fa-solid fa-check"
                    style="color: #00d5a5"
                  ></i>
                  <i v-else class="fa-solid fa-xmark" style="color: red"></i>
                </b-td>
                <b-td class="text-center">
                  <i
                    v-if="modules.allow_show_hide"
                    class="fa-solid fa-check"
                    style="color: #00d5a5"
                  ></i>
                  <i v-else class="fa-solid fa-xmark" style="color: red"></i>
                </b-td>
              </b-tr>
              <b-tr
                v-for="subModules in modules.sub_modules"
                :key="subModules.sub_module_id"
              >
                <b-td>
                  <p class="mx-2">
                    <i class="fa-solid fa-caret-right"></i>
                    {{ subModules.sub_module_name }}
                  </p>
                </b-td>
                <b-td class="text-center">
                  <i
                    v-if="subModules.allow_view"
                    class="fa-solid fa-check"
                    style="color: #00d5a5"
                  ></i>
                  <i v-else class="fa-solid fa-xmark" style="color: red"></i>
                </b-td>
                <b-td class="text-center">
                  <i
                    v-if="subModules.allow_show_hide"
                    class="fa-solid fa-check"
                    style="color: #00d5a5"
                  ></i>
                  <i v-else class="fa-solid fa-xmark" style="color: red"></i>
                </b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "HrAdminSettingModal",

  data() {
    return {
      permissionsFields: [
        {
          key: "Module / Submodule Name",
          sortable: true,
        },
        {
          key: "View",
          sortable: true,
        },
        {
          key: "Show / Hide",
          sortable: true,
        },
      ],
    };
  },

  computed: {
    getClientRolesModulesArr() {
      return this.$store.getters["settings/getClientRolesModulesArr"]
        .client_modules;
    },
    getSettingsModalFlag() {
      return this.$store.getters["systemMessage/getSettingsModalFlag"];
    },
    getClientDetailsForSettingsModalObj() {
      return this.$store.getters[
        "settings/getClientDetailsForSettingsModalObj"
      ];
    },
  },
  watch: {
    getSettingsModalFlag(getSettingsModalFlag) {
      if (getSettingsModalFlag) {
        this.$refs["my-hr-modal-setting"].show();
      } else if (!getSettingsModalFlag) {
        this.$refs["my-hr-modal-setting"].hide();
      }
    },
  },
  mounted() {
    this.$root.$on("bv::modal::hide", (bvEvent, modalId) => {
      this.$store.commit("systemMessage/SET_SETTINGS_MODAL_FLAG", false);
    });
  },
  methods: {},
};
</script>

<style>
.modal-header {
  padding: 1rem 1rem !important;
}
.modal-body {
  padding: 0rem 0rem 0 2rem !important;
}
</style>
